import { MentorPastSessionRow } from './MentorPortalService';

type Props = {
    sessions: MentorPastSessionRow[];
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
    isLoading: boolean;
    onPage: (page: number) => void;
};

const MentorPastSessionsPanel = ({
    sessions,
    page,
    pageSize,
    total,
    totalPages,
    isLoading,
    onPage,
}: Props) => {
    const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, total);

    return (
        <div className="msess-past">
            <p className="msess-past-lead">Sessions with your mentees. Dates are as logged (window-agnostic).</p>
            {isLoading && <p className="msess-empty">Loading…</p>}
            {!isLoading && sessions.length === 0 && (
                <p className="msess-empty">No sessions with your mentees yet.</p>
            )}
            {!isLoading && sessions.length > 0 && (
                <>
                    <div className="table-responsive">
                        <table className="table msess-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Mentee</th>
                                    <th>Duration</th>
                                    <th>Title</th>
                                    <th>Link</th>
                                    <th>Logged by</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sessions.map((row) => (
                                    <tr key={row.id}>
                                        <td>{row.occurredAt || '—'}</td>
                                        <td>{row.menteeName || '—'}</td>
                                        <td>{row.durationMinutes == null ? '—' : `${row.durationMinutes} min`}</td>
                                        <td>{row.title || '—'}</td>
                                        <td>
                                            {row.sessionLink ? (
                                                <a href={row.sessionLink} target="_blank" rel="noopener noreferrer">
                                                    Open link
                                                </a>
                                            ) : (
                                                '—'
                                            )}
                                        </td>
                                        <td>
                                            {row.loggedByRole ? (
                                                <span className="msess-role-chip">{row.loggedByRole}</span>
                                            ) : (
                                                '—'
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="msess-pager">
                        <span>
                            Showing {from}–{to} of {total}
                        </span>
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm"
                            disabled={page <= 1}
                            onClick={() => onPage(page - 1)}
                        >
                            Previous
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm"
                            disabled={page >= totalPages}
                            onClick={() => onPage(page + 1)}
                        >
                            Next
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default MentorPastSessionsPanel;
